import { COU_httpPost } from '@/utils/http'

// 授权淘特
async function TaoteAuth({ code }) {
  const url = '/taote/auth'
  const r = await COU_httpPost({ url, data: { code } })
  let msg = '', success = false
  try {
    success = r.success
    msg = r.msg
  }
  catch(error) {
    console.log(error)
  }
  if (msg?.includes('未绑定淘特')) msg = '当前未授权淘特账号，请先扫码完成授权。'
  return { success, msg }
}

// 解绑账号 (1688/淘特)
async function UnbindAccount(platformType) {
  const url = `/${platformType}/unbind`
  const r = await COU_httpPost({ url })
  let success = false, msg = ''
  try {
    success = r.success
    msg = r.msg
  } 
  catch (error) {
    console.log(error)
  }
  return { success, msg }
}


export default {
  TaoteAuth, UnbindAccount
}